globalThis.regeneratorRuntime = undefined;

import 'regenerator-runtime/runtime';

import setupWalkme from '@avalara/bat-apps-shared/server/walkme';
import { SContainer } from '@avalara/skylab-sdk/react';
import { configureStore } from '@reduxjs/toolkit';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import thunk from 'redux-thunk';

import { getBuydotEnv } from './conf';
import App from './containers/app';
import { initializeMockery } from './dev-tools/mockery';
import { isOneWebDomainRuntime } from './helpers/index';
import { isProdEnv } from './lib/helpers';
import reducer, { defaultState } from './reducers';
import '../../public/main.css';

import IntlProviderWrapper from './providers/IntlProviderWrapper';

const { __REDUX_DEVTOOLS_EXTENSION_COMPOSE__ } = window;

setupWalkme(getBuydotEnv());

const store = configureStore({
  reducer,
  preloadedState: defaultState,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
  devTools: !isProdEnv() && !!__REDUX_DEVTOOLS_EXTENSION_COMPOSE__,
});

type AppProvidersProps = {
  oneWebDomain: boolean;
};

function AppProviders({ oneWebDomain }: AppProvidersProps): JSX.Element {
  return (
    <IntlProviderWrapper>
      <Provider store={store}>
        <BrowserRouter basename={oneWebDomain ? '/buy' : undefined}>
          {oneWebDomain ? (
            <SContainer>
              <App />
            </SContainer>
          ) : (
            <App />
          )}
        </BrowserRouter>
      </Provider>
    </IntlProviderWrapper>
  );
}

function renderApp(): void {
  const oneWebDomain = isOneWebDomainRuntime();
  const root = oneWebDomain ? document.querySelector('main') : document.getElementById('react-root');
  if (!root) return;

  ReactDOM.createRoot(root).render(<AppProviders oneWebDomain={oneWebDomain} />);
}

async function startApp(): Promise<void> {
  await initializeMockery().catch((error: unknown) => {
    console.error('Mockery initialization failed', error);
  });
  renderApp();
}

void startApp();
